/**
 * Impl dos use cases de faturamento por parcela (commerce).
 *
 * @since G.5.20
 */
import type {
  NfseEmissao, EmitirNfseCommand, CobrancaGatewayResult, EmitirCobrancaCommand,
} from '@/domain/model/Faturamento';
import type { NfseGateway, CobrancaGatewayGateway } from '@/application/port/out/FaturamentoGateways';
import type {
  EmitirNfseUseCase, ConsultarNfseUseCase, EmitirCobrancaGatewayUseCase,
} from '@/application/port/in/FaturamentoUseCase';

export class EmitirNfse implements EmitirNfseUseCase {
  constructor(private readonly g: NfseGateway) {}
  execute(parcelaId: string, cmd: EmitirNfseCommand): Promise<NfseEmissao> { return this.g.emitir(parcelaId, cmd); }
}
export class ConsultarNfse implements ConsultarNfseUseCase {
  constructor(private readonly g: NfseGateway) {}
  execute(parcelaId: string): Promise<NfseEmissao> { return this.g.consultar(parcelaId); }
}
export class EmitirCobrancaGateway implements EmitirCobrancaGatewayUseCase {
  constructor(private readonly g: CobrancaGatewayGateway) {}
  execute(parcelaId: string, cmd: EmitirCobrancaCommand): Promise<CobrancaGatewayResult> { return this.g.emitir(parcelaId, cmd); }
}
